<template>
  <div class="dsfa-sc-data-center">
    <DsfSCPanel title="年度数据中心">
      <template #header>
        <div class="dsfa-sc-data-center-header__ft">
          <span>填报数量超过</span
          ><span class="dsfa-sc-data-center-header-number">99.99%</span
          ><span>本省用户</span>
        </div>
      </template>

      <div class="dsfa-sc-data-center-block-wrap">
        <DsfSCBlock
          class="dsfa-sc-data-center-block"
          v-for="(item, index) in blockList"
          :key="index"
          :bg-color="item.bgColor"
          :title="item.title"
          :number="item.number"
          :unit="item.unit"
        >
          <img
            class="dsfa-sc-data-center-block-icon"
            :src="utils.placehold(50, 50)"
            alt=""
          />
        </DsfSCBlock>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCDataCenter",
  ctrlCaption: "年度数据中心",
  mixins: [$mixins.control],
  data() {
    return {
      blockList: [
        {
          bgColor: "#f3f8fd",
          title: "累计上报数据",
          number: "2342",
          unit: "条",
        },
        {
          bgColor: "#f7f7fc",
          title: "正常上报率",
          number: "99%",
        },
        {
          bgColor: "#fef8f5",
          title: "同期全国正常上报",
          number: "89%",
        },
      ],
    };
  },
  components: {},
  created() {},
  methods: {},
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/dataCenter.scss';
</style>